import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Routes from './routes';
import UserAuthContext from './components/Context/userContext';
import LoadingContext from './components/Context/loadingContext';
import config from './config';
import { TextConfig } from './style';

const App = () => {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);

  const setUserAuth = (data) => {
    setUser(data);
  };

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const urltarget = `${config.API_BASE_URL}api/account/token/refresh/`;
      if (error.response) {
        if (error.response.status === 401) {
          if (originalRequest.url === urltarget) {
            window.localStorage.clear();
            window.location.href = `${config.API_BASE_URL}api/account/login`;
            return Promise.resolve();
          }

          const refreshToken = localStorage.getItem('refreshToken');
          if (refreshToken) {
            axios.post(`${config.API_BASE_URL}api/account/token/refresh/`, { refresh: refreshToken }, {
              headers: {
                'content-type': 'application/json',
                accept: 'application/json',
              },
            }).then((response) => {
              localStorage.setItem('accessToken', response.data.access);
              originalRequest.headers.Authorization = `Bearer ${response.data.access}`;
              return axios(originalRequest);
            });
          } else {
            window.location.href = `${config.API_BASE_URL}api/account/login`;
          }
        }
      }
      return Promise.reject(error);
    },
  );

  useEffect(() => {
    setLoading(false);
    if (window.localStorage.getItem('role')) {
      setUserAuth(window.localStorage.getItem('role'));
    }
    setLoading(true);
  }, []);

  const userData = {
    role: user,
    setUserAuth,
  };

  return (
    <LoadingContext.Provider value={loading}>
      <UserAuthContext.Provider value={userData}>
        <TextConfig>
          <Routes />
        </TextConfig>
      </UserAuthContext.Provider>
    </LoadingContext.Provider>
  );
};

export default App;
